// TODO: session expired?
import axios from "../../http";
import Constants from "./constants";
import router from "../../router"
import {TableActions, TableStates} from "@/store/tables/constants";

const state = {
    authenticated: false,  // пользователь полностью авторизован?
    user: undefined,
    loginMessage: null,
    authenticatedUserId: null, // аутентифицированный, но не авторизованный пользователь в случае 2f
};

export const USER_GROUPS = {
    CONTROLLER: 0b0000001,
    MUNICIPALITY: 0b0000010,
    CONTRACTOR: 0b0000100,
    CUSTOMER: 0b0001000,
}

export const USER_GROUP_NAMES = {
    1: 'Контроль',
    2: 'Ограничение по муниципалитету',
    4: 'Исполнитель',
    8: 'Заказчик',
}

export const ACTIVITIES = {
    CATCHING: 0b0000001,
    RELEASE: 0b0000010,
    VET: 0b0000100,
    KEEPING: 0b0001000,
    CONTROL: 0b0010000,
    MONITORING: 0b0100000,
}

export const ACTIVITY_NAMES = {
    1: 'Отлов',
    2: 'Выпуск',
    4: 'Ветеринарная помощь',
    8: 'Содержание',
    16: 'Контроль',
    32: 'Мониторинг'
}

const getters = {
    isAuthenticated: (s) => s.authenticated,  // полностью авторизован
    isSuperuser: (s, getters) => {
        return s.authenticated && s.user['is_superuser']
    },
    getLoginMessage: (s) => {
        return s.loginMessage
    },
    userId: (s) => {
        return s.user !== undefined ? s.user['id'] : 0
    },
    userObject: (s) => {
        return s.user !== undefined ? s.user : {}
    },
    userFullName: (s) => {
        return s.user !== undefined ? s.user['full_name'] : s
    },
    userPosition: (s) => {
        return s.user !== undefined ? s.user['position'] : s
    },
    userOrganization: (s) => {
        return s.user !== undefined && s.user['organization_object'] ? s.user['organization_object'] : {};
    },
    userOrganizationId: (s) => {
        return s.user !== undefined && s.user['organization'] ? s.user['organization'] : 0;
    },
    isInController: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'].indexOf(USER_GROUPS.CONTROLLER) >= 0 : false;
    },
    isInContractor: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'].indexOf(USER_GROUPS.CONTRACTOR) >= 0 : false;
    },
    isInCustomer: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'].indexOf(USER_GROUPS.CUSTOMER) >= 0 : false;
    },
    isMunicipalController: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'].indexOf(USER_GROUPS.CONTROLLER) >= 0
            && s.user['organization_object']['group_list'].indexOf(USER_GROUPS.MUNICIPALITY) >= 0 : false;
    },
    isShelter: (s, getters) => {
        return !getters.isInController
            && getters.isInContractor
            && getters.userOrganizationActivities.includes(ACTIVITIES.KEEPING);
    },
    isVetControl: (s, getters) => {
        return getters.userOrganizationActivities.includes(ACTIVITIES.CONTROL) && getters.userOrganizationActivities.includes(ACTIVITIES.VET);
    },
    hasMunicipalityRestrictions: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'].indexOf(USER_GROUPS.MUNICIPALITY) >= 0 : false;
    },
    userGroups: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['group_list'] : [];
    },
    userOrganizationMunicipalities: (s) => {
        return s.user !== undefined && s.user['organization_object']
        && s.user['organization_object']['municipalities']
        && s.user['organization_object']['municipalities'].length ? s.user['organization_object']['municipalities'] : [];
    },
    userOrganizationMunicipalityNames: (s) => {
        return s.user !== undefined && s.user['organization_object']
        && s.user['organization_object']['municipality_names']
        && s.user['organization_object']['municipality_names'].length ? s.user['organization_object']['municipality_names'] : {};
    },
    userOrganizationActivities: (s) => {
        return s.user !== undefined && s.user['organization_object'] ?
            s.user['organization_object']['activity_list'] : [];
    },
    userLastValidContract: (s) => {
        if (s.user !== undefined && s.user['last_valid_contract'])
            return s.user['last_valid_contract'];
        return null;
    },
    userLastValidContractObject: (s) => {
        if (s.user !== undefined && s.user['last_valid_contract_object'])
            return s.user['last_valid_contract_object'];
        return null;
    },
    userValidContractObjects: (s) => {
        if (s.user !== undefined && s.user['valid_contract_objects'])
            return s.user['valid_contract_objects'];
        return null;
    },
    userValidContractObjectIds: (s, getters) => {
        if (s.user !== undefined && s.user['valid_contract_objects']) {
            let contractIds = [];
            for (const contractObject of getters.userValidContractObjects) {
                contractIds.push(contractObject['id'])
            }
            return contractIds;
        }
        return null;
    },
    canBeContracted: (s, getters) => {
        return getters.isInContractor;
    },
    authenticatedUserId: (s) => s.authenticatedUserId,
};

const mutations = {
    [Constants.AuthStates.AUTH_LOGIN_SUCCESS]: (state, payload) => {
        state.authenticated = true;
        state.user = payload.data.user;
        state.authenticatedUserId = null;
    },
    [Constants.AuthStates.AUTH_LOGIN_FAILURE]: (state) => {
        state.authenticated = false;
        state.user = undefined;
        state.authenticatedUser = null;
    },
    [Constants.AuthStates.AUTH_LOGOUT_SUCCESS]: (state, payload) => {
        state.authenticated = false;
        state.user = undefined;
        state.loginMessage = payload.data ? payload.data.message : null;
        state.authenticatedUserId = null;
    },
    [Constants.AuthStates.AUTH_LOGOUT_FAILURE]: (state) => {

    },
    [Constants.AuthStates.AUTH_AUTHENTICATION_SUCCESS]: (state, payload) => {
        state.authenticatedUserId = payload.userId;
    },
    [Constants.AuthStates.AUTH_CURRENT_CONTRACT_SUCCESS]: (state, payload) => {
        state.user['last_valid_contract'] = payload['id'];
        state.user['last_valid_contract_object'] = payload;
    },
};

const actions = {
    [Constants.AuthActions.AUTH_LOGIN]: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
           axios
            .post('/accounts/login/', user)
            .then((response) => {
                if (response.data['needs_confirmation']) {
                    commit(Constants.AuthStates.AUTH_AUTHENTICATION_SUCCESS, {userId: response.data['user_id']});
                    resolve(false);
                } else {
                    commit(Constants.AuthStates.AUTH_LOGIN_SUCCESS, response);
                    resolve(true);
                }
            })
            .catch(reason => {
                commit(Constants.AuthStates.AUTH_LOGIN_FAILURE, reason);
                reject(reason);
            });
        });

    },
    [Constants.AuthActions.AUTH_LOGOUT]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            axios
                .post('/accounts/logout/')
                .then((response) => {
                    commit(Constants.AuthStates.AUTH_LOGOUT_SUCCESS, {response: response, data: data});
                    commit(TableStates.TABLE_EMPTY_FILTERS, null, { root: true })
                    commit(TableStates.TABLE_EMPTY_SEARCH, null, { root: true })
                    resolve(response);
                })
                .then(() => {
                    router.push('/login');
                })
                .catch(reason => {
                    commit(Constants.AuthStates.AUTH_LOGOUT_FAILURE, reason);
                    reject(reason);
                });
        });
    },
    [Constants.AuthActions.AUTH_UPDATE_USER]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            commit(Constants.AuthStates.AUTH_LOGIN_SUCCESS, { data: { user: data.user }  });
            resolve();
        });
    },
    [Constants.AuthActions.AUTH_AUTHENTICATE]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
           commit(Constants.AuthStates.AUTH_AUTHENTICATION_SUCCESS, data);
           resolve();
        });
    },
    [Constants.AuthActions.AUTH_CHANGE_CURRENT_CONTRACT]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            if (data && data['id'] && data['customer_object'] && data['contractor_object']) {
                commit(Constants.AuthStates.AUTH_CURRENT_CONTRACT_SUCCESS, data);
                resolve();
            } else {
                reject();
            }
        });
    },
};

export default {
    Constants,
    state,
    getters,
    mutations,
    actions
}


